export default __webpack_public_path__ + "static/media/042.9262efa6.jpg";